import React from 'react';
import { Box, Typography } from '@mui/material';

type LegacyReconciliationSummaryTileProps = {
  title: string;
  value: string | React.ReactNode;
  subtext?: string | React.ReactNode;
  footer?: string;
  cardClassName?: string;
  valueClassName?: string;
};

const LegacyReconciliationSummaryTile: React.FC<LegacyReconciliationSummaryTileProps> = ({
  title,
  value,
  subtext,
  footer,
  cardClassName,
  valueClassName,
}) => {
  return (
    <Box>
      <Box className={`audit-report-card ${cardClassName || ''}`} sx={{ width: '100%' }}>
        <Box className="audit-report-card-header">
          <Typography className="audit-report-card-title">
            {title}
          </Typography>
        </Box>
        <Box className="audit-report-card-body">
          <Box className="audit-report-card-content">
            <Box className={`audit-report-card-value ${valueClassName || ''}`}>
              {value}
            </Box>
            {subtext !== undefined && (
              <Box className="audit-report-card-subtext">
                {subtext}
              </Box>
            )}
          </Box>
          {footer ? (
            <Box className="audit-report-card-divider">
              <Typography className="audit-report-card-footer">
                {footer}
              </Typography>
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default React.memo(LegacyReconciliationSummaryTile);
